import React from "react";

import {
  Bold,
  Button,
  Card,
  Copy,
  Gradient,
  Icon,
  InternalImage,
  Row,
  Title,
  Wrapper
} from "app/NativeComponents/common";

import moment from "moment";
import { store } from "app/store";
import { iconTurnMap } from "app/NativeActions";

const editDirectionMessage = message => {
  message = message.replace("You have arrived at", "Arriving soon at");
  message = message.replace("Your destination", "Property");
  return message;
};

const renderDirection = function (props) {
  let route_in_step = props.route_plan_step;
  const colors = store.getState().settings.colors;
  let icon = "";

  icon = (
    <InternalImage
      style={{ marginRight: 10, width: 50, height: 50 }}
      source={iconTurnMap(
        props.route_plan_legs.instructions[props.route_plan_step]
          ? props.route_plan_legs.instructions[props.route_plan_step - 1]
            ? props.route_plan_legs.instructions[props.route_plan_step - 1]
                .completed
              ? props.route_plan_legs.instructions[props.route_plan_step]
                  .maneuver
              : props.route_plan_legs.instructions[props.route_plan_step - 1]
                  .maneuver
            : props.route_plan_legs.instructions[props.route_plan_step].maneuver
          : ""
      )}
    />
  );

  return (
    <Gradient
      style={{
        flex: 1,
        padding: 10,
        justifyContent: "space-between",
        maxWidth: "100%",
        height: "auto",
        borderTopLeftRadius: 10,
        borderTopRightRadius: 10,
        borderBottomRightRadius: 10,
        borderBottomLeftRadius: props.route_plan_distance_left <= 0.03 ? 10 : 0,
        shadowColor: "#000",
        shadowOpacity: 0.1,
        shadowOffset: { width: 0, height: 2 },
        elevation: 5,
        marginTop: props.platform == "ios" ? 15 : 0
      }}
      color1={colors.side_gradient_color_1}
      color2={colors.side_gradient_color_2}
    >
      <Row>
        <Wrapper style={{ width: "20%" }}>{icon}</Wrapper>
        <Wrapper style={{ width: "80%" }}>
          <Copy style={{ fontSize: 24, color: "white", fontWeight: "bold" }}>
            {props.route_plan_distance_left <= 0.03
              ? "You have arrived..."
              : props.route_plan_legs.instructions[props.route_plan_step]
              ? props.route_plan_legs.instructions[props.route_plan_step - 1]
                ? props.route_plan_legs.instructions[props.route_plan_step - 1]
                    .completed
                  ? editDirectionMessage(
                      props.route_plan_legs.instructions[props.route_plan_step]
                        .message
                    )
                  : editDirectionMessage(
                      props.route_plan_legs.instructions[
                        props.route_plan_step - 1
                      ].message
                    )
                : editDirectionMessage(
                    props.route_plan_legs.instructions[props.route_plan_step]
                      .message
                  )
              : ""}
          </Copy>
        </Wrapper>
      </Row>
    </Gradient>
  );
};

const TrackingBar = props => {
  const colors = store.getState().settings.colors;
  if (
    props.track_route &&
    !props.autocomplete_loading &&
    !props.focused &&
    props.autocomplete_items.length == 0 &&
    (props.device === "mobile" || props.isMobile)
  ) {
    if (props.route_plan_active && props.route_plan_legs) {
      return (
        <Wrapper
          style={{
            marginTop: -10,
            marginLeft: 10,
            marginRight: 10
          }}
        >
          {renderDirection(props)}

          {!props.route_plan_legs.instructions[
            props.route_plan_legs.instructions.length - 2
          ].completed ? (
            <Row
              style={{
                backgroundColor:
                  props.dark_mode === "dark_mode" ? "#323F4B" : "#30706E",
                padding: 10,
                width: 90,
                shadowColor: "#000",
                shadowOpacity: 0.1,
                shadowOffset: { width: 0, height: 2 },
                elevation: 5,
                borderBottomLeftRadius: 10,
                borderBottomRightRadius: 10
              }}
            >
              <Copy
                style={{ fontSize: 16, color: "white", fontWeight: "bold" }}
              >
                Then
              </Copy>
              <InternalImage
                style={{ marginLeft: 5, width: 30, height: 30 }}
                source={iconTurnMap(
                  props.route_plan_legs.instructions[props.route_plan_step]
                    ? props.route_plan_legs.instructions[
                        props.route_plan_step - 1
                      ]
                      ? props.route_plan_legs.instructions[
                          props.route_plan_step - 1
                        ].completed
                        ? props.route_plan_legs.instructions[
                            props.route_plan_step + 1
                          ].maneuver
                        : props.route_plan_legs.instructions[
                            props.route_plan_step
                          ].maneuver
                      : props.route_plan_legs.instructions[
                          props.route_plan_step + 1
                        ].maneuver
                    : ""
                )}
              />
            </Row>
          ) : null}
        </Wrapper>
      );
    } else if (props.route_plan_completed && !props.is_loading) {
      return (
        <Wrapper
          style={{
            marginTop: -10,
            marginLeft: 10,
            marginRight: 10
          }}
        >
          <Gradient
            style={{
              flex: 1,
              padding: 10,
              justifyContent: "space-between",
              maxWidth: "100%",
              height: "auto",
              borderTopLeftRadius: 10,
              borderTopRightRadius: 10,
              borderBottomRightRadius: 10,
              borderBottomLeftRadius: 10,
              shadowColor: "#000",
              shadowOpacity: 0.1,
              shadowOffset: { width: 0, height: 2 },
              elevation: 5,
              marginTop: props.platform == "ios" ? 15 : 0
            }}
            color1={colors.side_gradient_color_1}
            color2={colors.side_gradient_color_2}
          >
            <Wrapper>
              <Copy
                style={{
                  textAlign: "center",
                  fontSize: 24,
                  color: "white",
                  fontWeight: "bold"
                }}
              >
                Planned Route Completed
              </Copy>
              <Copy
                style={{ textAlign: "center", fontSize: 16, color: "white" }}
              >
                There are no more properties left on your planned route. You can
                finish the planned route by clicking "Stop Driving"
              </Copy>
            </Wrapper>
          </Gradient>
        </Wrapper>
      );
    } else if (!props.route_plan_active) {
      return (
        <Wrapper
          style={
            props.device == "desktop"
              ? {
                  borderTopColor: props.colors.border_color,
                  borderTopWidth: 1,
                  borderTopStyle: "solid",
                  width: "100%",
                  backgroundColor: props.colors.background_color
                }
              : {
                  borderTopColor: props.colors.border_color,
                  borderTopWidth: 1,
                  width: "100%",
                  backgroundColor: props.colors.background_color
                }
          }
        >
          <Row
            style={{
              paddingLeft: 10,
              paddingRight: 10
            }}
          >
            <Wrapper
              style={{
                flex: 1,
                height: 65,
                alignItems: "center",
                justifyContent: "center"
              }}
            >
              <Row
                style={{
                  alignItems: "center",
                  justifyContent: "center",
                  maxWidth: 600,
                  width: "100%"
                }}
              >
                <Wrapper
                  style={{
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Copy style={{ fontSize: 10 }}>Deals Added:</Copy>
                  <Title style={{ fontSize: 16 }}>
                    {props.total_deals_added}
                  </Title>
                </Wrapper>
                <Wrapper
                  style={{
                    marginLeft: 15,
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Copy style={{ fontSize: 10 }}>Miles Driven:</Copy>
                  <Title style={{ fontSize: 16 }}>{props.total_miles} mi</Title>
                </Wrapper>
                <Wrapper
                  style={{
                    marginLeft: 15,
                    flex: 1,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Copy style={{ fontSize: 10 }}>Time Driven:</Copy>
                  <Title style={{ fontSize: 16 }}>{props.total_time}</Title>
                </Wrapper>

                <Wrapper
                  style={{
                    height: 65,
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <Button
                    onPress={() => {
                      if (props.map_mode != "glide") {
                        props.selectActiveProperty(null);
                      }
                      if (props.current_route) {
                        props.setModal({
                          title: "Are you finished with your drive?",
                          description:
                            "Are you sure you want to stop driving and complete your route?",
                          submit: "Stop Driving",
                          onPress: () => {
                            props.stopTrackedRoute({
                              token: props.token,
                              route_id: props.current_route.route_id,
                              start_time: props.current_route_section
                                ? props.current_route_section.start_time
                                : moment().format("YYYY-MM-DD HH:mm:ss"),
                              coordinates: props.current_route_section
                                ? props.current_route_section.coordinates
                                : [],
                              current_route: props.current_route
                            });
                            if (props.route_plan_active) {
                              props.stopPlannedRoute({ token: props.token });
                            }
                          },
                          cancel: "Not yet",
                          onCancel: () => {}
                        });
                        props.toggleModal({ show: true, type: "normal" });
                      }
                    }}
                  >
                    <Card
                      style={{
                        borderRadius: 30,
                        padding: 5,
                        paddingRight: 10,
                        paddingLeft: 10,
                        backgroundColor: props.colors.error_color,

                        alignSelf: "flex-start"
                      }}
                    >
                      <Row>
                        <Wrapper>
                          <Row>
                            <Wrapper
                              style={{
                                marginRight: 5,
                                alignItems: "center",
                                justifyContent: "center"
                              }}
                            >
                              <Icon
                                icon="stop"
                                size={20}
                                color={props.colors.white_text_color}
                              />
                            </Wrapper>
                            <Wrapper>
                              <Copy
                                style={{ color: props.colors.white_text_color }}
                              >
                                <Bold>Stop</Bold>
                              </Copy>
                            </Wrapper>
                          </Row>
                        </Wrapper>
                      </Row>
                    </Card>
                  </Button>
                </Wrapper>
              </Row>
            </Wrapper>
          </Row>
        </Wrapper>
      );
    }
  }

  return <Wrapper />;
};

export default React.memo(TrackingBar);
